import { useEffect, useState } from 'react';
import { getErrorMessage, getUser } from '../../helpers/lib/axios';
import LoadingSpinner from '../LoadingSpinner';

/** Fetches the signed-in user and shows their details. Used by both the client and admin profile pages. */
export default function ProfileCard({ showGender = true }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        getUser()
            .then((res) => setUser(res?.data ?? null))
            .catch((err) => setError(getErrorMessage(err, 'Failed to load your profile.')))
            .finally(() => setLoading(false));
    }, []);

    const fullName = [user?.firstName, user?.lastName].filter(Boolean).join(' ');

    let content;
    if (loading) {
        content = <div className="px-6 py-4"><LoadingSpinner /></div>;
    } else if (error || !user) {
        content = <p className="p-6 text-center text-[#981D0E]">{error || 'Profile not available.'}</p>;
    } else {
        content = (
            <div className="p-6">
                <h2 className="text-xl font-semibold text-gray-800">Name: {fullName || '—'}</h2>
                <p className="text-gray-600">Email: {user.email}</p>
                {showGender && <p className="mt-4 text-gray-500">Gender: {user.gender || "No gender available."}</p>}
            </div>
        );
    }

    return (
        <div className="px-6">
        <div className="max-w-sm lg:max-w-lg mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
            <div className="bg-gray-100 py-4">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-28 h-28 mx-auto rounded-full border-[4px] border-white p-2">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zM4 20c0-4.418 3.582-8 8-8s8 3.582 8 8H4z" />
                </svg>
            </div>
            {content}
        </div>
        </div>
    );
}
